module.exports = __webpack_public_path__ + "static/media/PY.e6a6e396.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PY.svg
// module id = 2246
// module chunks = 7